import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const privacyContent = <>
      <h4 className="text-lg font-bold text-[#D4AF37] mb-2" data-id="element-27">
        1. Recopilación de Información
      </h4>
      <p className="mb-4" data-id="element-28">
        Recopilamos información que usted nos proporciona directamente cuando
        realiza una compra, se suscribe a nuestro boletín o se comunica con
        nosotros. Esta información puede incluir su nombre, dirección de correo
        electrónico e información de pago.
      </p>

      <h4 className="text-lg font-bold text-[#D4AF37] mb-2" data-id="element-29">
        2. Uso de la Información
      </h4>
      <p className="mb-4" data-id="element-30">
        Utilizamos la información recopilada para procesar sus transacciones,
        enviarle el contenido digital adquirido y proporcionarle actualizaciones
        sobre nuestros productos. No vendemos ni compartimos su información
        personal con terceros con fines comerciales.
      </p>

      <h4 className="text-lg font-bold text-[#D4AF37] mb-2" data-id="element-31">
        3. Cookies y Tecnologías Similares
      </h4>
      <p className="mb-4" data-id="element-32">
        Utilizamos cookies para mejorar su experiencia en nuestro sitio web,
        analizar el tráfico y personalizar el contenido. Puede configurar su
        navegador para rechazar todas las cookies o para que le avise cuando se
        envíe una cookie.
      </p>

      <h4 className="text-lg font-bold text-[#D4AF37] mb-2" data-id="element-33">
        4. Seguridad de los Datos
      </h4>
      <p className="mb-4" data-id="element-34">
        Implementamos medidas de seguridad razonables para proteger su
        información personal contra el acceso no autorizado, la alteración, la
        divulgación o la destrucción.
      </p>

      <h4 className="text-lg font-bold text-[#D4AF37] mb-2" data-id="element-35">5. Sus Derechos</h4>
      <p className="mb-4" data-id="element-36">
        Usted tiene derecho a acceder, corregir o eliminar su información
        personal. Si desea ejercer estos derechos, por favor contáctenos a
        través de los canales oficiales.
      </p>
    </>;
  const termsContent = <>
      <h4 className="text-lg font-bold text-[#D4AF37] mb-2" data-id="element-37">
        1. Aceptación de los Términos
      </h4>
      <p className="mb-4" data-id="element-38">
        Al acceder y utilizar este sitio web y adquirir nuestros productos
        digitales, usted acepta estar sujeto a estos Términos de Servicio y a
        todas las leyes y regulaciones aplicables.
      </p>

      <h4 className="text-lg font-bold text-[#D4AF37] mb-2" data-id="element-39">
        2. Propiedad Intelectual
      </h4>
      <p className="mb-4" data-id="element-40">
        Todo el contenido incluido en este sitio y en los productos digitales
        (texto, gráficos, logotipos, imágenes, clips de audio, descargas
        digitales) es propiedad de Protagonistas de Nuestro Tiempo y está
        protegido por las leyes internacionales de derechos de autor.
      </p>

      <h4 className="text-lg font-bold text-[#D4AF37] mb-2" data-id="element-41">
        3. Licencia de Uso
      </h4>
      <p className="mb-4" data-id="element-42">
        Se le concede una licencia limitada, no exclusiva e intransferible para
        acceder y hacer uso personal y no comercial de los productos digitales
        adquiridos. No está permitido modificar, copiar, distribuir, transmitir,
        mostrar, ejecutar, reproducir, publicar, licenciar, crear trabajos
        derivados, transferir o vender ninguna información o contenido obtenido.
      </p>

      <h4 className="text-lg font-bold text-[#D4AF37] mb-2" data-id="element-43">
        4. Política de Reembolso
      </h4>
      <p className="mb-4" data-id="element-44">
        Debido a la naturaleza digital de nuestros productos, todas las ventas
        son finales. No ofrecemos reembolsos una vez que se ha proporcionado el
        acceso a la descarga del contenido.
      </p>

      <h4 className="text-lg font-bold text-[#D4AF37] mb-2" data-id="element-45">
        5. Limitación de Responsabilidad
      </h4>
      <p className="mb-4" data-id="element-46">
        Protagonistas de Nuestro Tiempo no será responsable de ningún daño
        directo, indirecto, incidental, especial o consecuente que resulte del
        uso o la imposibilidad de usar nuestros productos.
      </p>
    </>;
  return <>
      <footer className="py-12 px-4 border-t border-gray-800 bg-[#0a0a0a]" data-id="element-47">
        <div className="max-w-4xl mx-auto text-center" data-id="element-48">
          <p className="text-gray-500 text-sm mb-4" data-id="element-49">
            © 2026 Protagonistas de Nuestro Tiempo. Todos los derechos
            reservados.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mb-6" data-id="element-50">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-[#D4AF37] transition-colors underline decoration-gray-700 underline-offset-4 hover:decoration-[#D4AF37]" data-id="element-51">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-[#D4AF37] transition-colors underline decoration-gray-700 underline-offset-4 hover:decoration-[#D4AF37]" data-id="element-52">
              Términos de Servicio
            </button>
          </div>

          <p className="text-gray-600 text-xs max-w-lg mx-auto" data-id="element-53">
            Contenido educativo e histórico. Enfoque neutral y documentado. Este
            sitio no está afiliado con ninguna entidad gubernamental o partido
            político.
          </p>
        </div>
      </footer>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-54">
        {privacyContent}
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos de Servicio" data-id="element-55">
        {termsContent}
      </LegalModal>
    </>;
}